// extracted by mini-css-extract-plugin
export default {"beamCheckbox":"beam-checkbox_beamCheckbox__yOHfe"};